import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared';
import { LoginComponent } from './layout/login/login.component';
import { environment } from 'src/environments/environment';

const routes: Routes = [
	{ path: '', loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule), canActivate: [AuthGuard] },
	{ path: 'login', component: LoginComponent, data: { mxApp: '/ma-analisecredito', mxRootPath: 'ma-analisecredito-view', mxEnvironment: environment } },
	{ path: 'changePassword', component: LoginComponent, data: { mxApp: '/ma-analisecredito', mxRootPath: 'ma-analisecredito-view', mxEnvironment: environment } },
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { useHash: true })],
	exports: [RouterModule]
})
export class AppRoutingModule { }
